import request from '../utils/request'

export function sendCode(data) { // 发送短信动态码
  return request({
    url: '/basic/sendCode',
    method: 'POST',
    data
  })
}
